import WebApiService from "@/services/webapi.service.js";

const state = {
    centroMedico: null,
    listaCentri: null,
    markers: null
}

const getters = {

    getMarkers: state => {
        return state.markers ? state.markers : JSON.parse(sessionStorage.getItem("markers"));
    },
    getCentri: state => {       
        return state.listaCentri ? state.listaCentri : JSON.parse(sessionStorage.getItem("listaCentri"));
    },
    getCentro: state => { 
        let centro =  state.centroMedico ? state.centroMedico : JSON.parse(sessionStorage.getItem("centro"));
        return centro;
    },
   
    getIndirizzoCompleto: state => {
        
        let centroMedico = state.centroMedico ? state.centroMedico : JSON.parse(sessionStorage.getItem("centro"));

        if(centroMedico.indirizzo && centroMedico.indirizzo != "-"){      
            return centroMedico.indirizzo + ", " + centroMedico.citta + "("+ centroMedico.provincia +")";
        }
        else{
            return "-";
        }
       
    }
}

const mutations = {
    setCentro(state, centro){
      state.centroMedico = centro
      sessionStorage.setItem("centro", JSON.stringify(centro));
    },
    setListaCentri(state, listaCentri){
        state.listaCentri = listaCentri;
        sessionStorage.setItem("listaCentri", JSON.stringify(listaCentri));
    },
    setMarkers(state, markers){
        state.markers = markers;
        sessionStorage.setItem("markers", JSON.stringify(markers));
    }
}

const actions = {
    getCentriMedici({commit}, datiCentri){
        debugger
        return WebApiService.get('CentroMedico/GetCentriMedici', {}).then(
            (data) => { 
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                                       
                    commit("setListaCentri", data.Data);
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
            )
            .catch(              
                error => {return [false, ""]}
            );
    }
}

export default{

    //namespaced: true,
    state,
    getters,
    actions,
    mutations
}